import type {CSSProperties} from "react";

export const ACCOUNT_SKELETON_WIDTHS = [
    "58%",
    "72%",
    "48%",
    "64%",
    "55%",
    "70%",
    "42%",
    "66%",
    "51%",
    "60%",
];

export const AMOUNT_SKELETON_WIDTHS = ["3.25rem", "2.75rem", "3.5rem", "2.5rem", "3rem"];

export const SKELETON_INDENTS = [
    "pl-3",
    "pl-3",
    "pl-8",
    "pl-8",
    "pl-12",
    "pl-3",
    "pl-8",
    "pl-12",
    "pl-8",
    "pl-3",
];

export function ShimmerBar({
    className,
    style,
}: {
    className?: string;
    style?: CSSProperties;
}) {
    return (
        <div
            className={`h-3.5 animate-shimmer rounded bg-gray-100 bg-[linear-gradient(105deg,#f3f4f6_30%,#eceef0_50%,#f3f4f6_70%)] bg-[length:200%_100%] motion-reduce:animate-none ${className ?? ""}`}
            style={style}
        />
    );
}

export function EmptyBoxIcon() {
    return (
        <svg
            width="64"
            height="41"
            viewBox="0 0 64 41"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
        >
            <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                <ellipse cx="32" cy="33" rx="32" ry="7" fill="#F5F5F5" />
                <g fillRule="nonzero" stroke="#D9D9D9">
                    <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z" />
                    <path
                        d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                        fill="#FAFAFA"
                    />
                </g>
            </g>
        </svg>
    );
}

export function EmptyTableBody({
    colSpan,
    message = "Geen gegevens voor deze filters",
}: {
    colSpan: number;
    message?: string;
}) {
    return (
        <tr>
            <td colSpan={colSpan} className="px-6 py-16">
                <div className="flex flex-col items-center justify-center gap-2 text-center">
                    <EmptyBoxIcon />
                    <p className="mt-1 text-[14px] text-gray-400">{message}</p>
                </div>
            </td>
        </tr>
    );
}

export function SkeletonAccountCell({rowIndex}: {rowIndex: number}) {
    return (
        <td
            className={`sticky left-0 z-10 bg-white px-3 py-2.5 border-r border-r-gray-300 ${
                SKELETON_INDENTS[rowIndex % SKELETON_INDENTS.length]
            }`}
        >
            <ShimmerBar
                style={{
                    width: ACCOUNT_SKELETON_WIDTHS[rowIndex % ACCOUNT_SKELETON_WIDTHS.length],
                }}
            />
        </td>
    );
}

export function SkeletonAmountCell({
    rowIndex,
    colIndex,
    withLeftBorder,
    className,
}: {
    rowIndex: number;
    colIndex: number;
    withLeftBorder?: boolean;
    className?: string;
}) {
    return (
        <td
            className={`px-3 py-2.5 text-right ${
                withLeftBorder ? "border-l border-l-gray-300" : ""
            } ${className ?? ""}`}
        >
            <ShimmerBar
                className="ml-auto"
                style={{
                    width:
                        AMOUNT_SKELETON_WIDTHS[(rowIndex + colIndex) % AMOUNT_SKELETON_WIDTHS.length],
                }}
            />
        </td>
    );
}

